'use client';

import React from 'react';
import HeroSection from './HeroSection';
import ValuePropositionSection from './ValuePropositionSection';
import PreCallAssessmentForm from './PreCallAssessmentForm';
import TrustIndicatorsSection from './TrustIndicatorsSection';
import SocialProofCarousel from './SocialProofCarousel';
import CaseStudyShowcase from './CaseStudyShowcase';
import BookingCalendar from './BookingCalendar';
import Footer from './Footer';

const DiscoveryCallBookingInteractive = () => {
  return (
    <main className="pt-16 lg:pt-20">
      <HeroSection />
      <ValuePropositionSection />
      <TrustIndicatorsSection />
      <SocialProofCarousel />
      <PreCallAssessmentForm />
      <CaseStudyShowcase />
      <BookingCalendar />
      <Footer />
    </main>
  );
};

export default DiscoveryCallBookingInteractive;